import { Badge } from "@shadcn/ui/badge";
import React, { PropsWithChildren } from "react";

type TProps = {
	children: string;
};

export const T = (props: TProps) => {
	return (
		<span>
			{props.children.split("\n").map((line, index, array) => (
				// Lines can repeat (e.g. blank lines) and never reorder, so the index is the key.
				<React.Fragment key={index}>
					<TextLine line={line} />
					{index < array.length - 1 && <br />}
				</React.Fragment>
			))}
		</span>
	);
};

const Underline = ({ children }: PropsWithChildren) => <span className="underline">{children}</span>;
const Bold = ({ children }: PropsWithChildren) => <span className="font-medium">{children}</span>;
const BadgeGreen = ({ children }: PropsWithChildren) => (
	<Badge variant="default" className="font-semibold  bg-green-200 text-green-950 mx-1 px-1">
		{children}
	</Badge>
);
const PrivacyPolicy = ({ children }: PropsWithChildren) => (
	<a className="underline" href="https://bacehub.de/privacy-policy" target="_blank">
		{children}
	</a>
);
const Bacehub = ({ children }: PropsWithChildren) => (
	<a className="underline" href="https://bacehub.de" target="_blank" rel="noopener noreferrer">
		{children}
	</a>
);
const Instagram = ({ children }: PropsWithChildren) => (
	<a
		className="underline"
		href="https://www.instagram.com/bace.hub/"
		target="_blank"
		rel="noopener noreferrer"
	>
		{children}
	</a>
);
const Linkedin = ({ children }: PropsWithChildren) => (
	<a
		className="underline"
		href="https://www.linkedin.com/company/bacehub"
		target="_blank"
		rel="noopener noreferrer"
	>
		{children}
	</a>
);

const componentMap = {
	underline: Underline,
	bold: Bold,
	badgeGreen: BadgeGreen,
	privacyPolicy: PrivacyPolicy,
	bacehub: Bacehub,
	instagram: Instagram,
	linkedin: Linkedin,
};

const tags = Object.keys(componentMap);
const regex = new RegExp(`<(${tags.join("|")})>(.*?)<\\/\\1>`);

const TextLine = (props: { line: string }) => {
	const { line } = props;
	const parseText = (text: string): string | React.ReactNode => {
		const match = text.match(regex);
		if (!match) return text;

		const [fullMatch, tag, content] = match;
		if (!tags.includes(tag as string)) {
			throw new Error(`Invalid tag: ${tag}`);
		}
		const Component = componentMap[tag as keyof typeof componentMap];

		return [
			text.slice(0, match.index),
			<Component key={match.index}>{content && parseText(content)}</Component>,
			match.index && parseText(text.slice(match.index + fullMatch.length)),
		].filter(Boolean);
	};

	return parseText(line);
};
